import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { IntroductionButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';
import Introduction from '@Components/Introduction';

import {
  BusinessValueChainFormValues,
  IImpactsOnStakeholdersFormValues,
} from '../ImpactsOnStakeholdersFormProvider/types';
import { useImpactsOnStakeholdersForm } from '../ImpactsOnStakeholdersFormProvider';

export const BUSINESS_INTRODUCTION_ID = 'business-introduction';

const BusinessValueChainIntroduction = () => {
  const { control, getValues } = useImpactsOnStakeholdersForm();
  const { introduction } =
    getValues(`businessValueChain`) ?? ({} as IImpactsOnStakeholdersFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const businessIntroductionEl = document.getElementById(
    BUSINESS_INTRODUCTION_ID
  );

  const { completedSection } =
    useWatch({
      name: 'businessValueChain',
      control,
    }) ?? ({} as BusinessValueChainFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        businessIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="ห่วงโซ่คุณค่าธุรกิจ"
              setOpen={open}
              fieldPath="businessValueChain.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          businessIntroductionEl
        )}
    </>
  );
};

export default BusinessValueChainIntroduction;
